import React from "react";

const Notification = (props) => {
	return (
        <svg className="menu-icon" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M19.01,34.1c-.12.44-.2.89-.2,1.37,0,2.87,2.33,5.2,5.2,5.2s5.2-2.33,5.2-5.2c0-.48-.08-.93-.2-1.37" fill="none" stroke={props.color} strokeLinejoin="round" strokeWidth="2.75"/><path d="M37.15,30.7c-1.69-1.73-2.82-4.01-2.82-6.98,0-1.81.15-6.17-.94-8.11-1.45-2.59-4.33-4.46-5.61-5.19-.75-.43-1.03-3.08-3.78-3.08s-3.03,2.64-3.78,3.08c-1.28.74-4.17,2.6-5.61,5.19-1.08,1.94-.94,6.31-.94,8.11,0,2.97-1.14,5.26-2.82,6.98-1.89,1.93-.97,3.4.55,3.4h25.19c1.52,0,2.44-1.46.55-3.4Z" fill="none" stroke={props.color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.75"/></svg>
	);
};

export default Notification;
